import request from '../../../src/utils/request'

export const getAttendanceGovernanceOverview = () => {
  return request({
    url: '/addon/attendanceGovernance/overview',
    method: 'get'
  })
}
